import React from 'react';
import cn from 'classnames';

import styles from './Divider.module.scss';

type Props = { className?: string };

export const Divider = ({ className }: Props) => (
  <div className={cn(styles.container, className)}>
    <div className={styles.divider} />
  </div>
);
